import { Program } from '~source/core/models/tv-guide';

export const isLiveProgram = (program: Program): boolean => {
    const now = new Date();
    const startDate = new Date(program.dateStart);
    const endDate = new Date(program.dateEnd);
    return startDate < now && now < endDate;
};
